<template>
  <v-app id="nwHuov">
    <v-main>
     <v-container fluid>
         <!-- Nieuwe HUOV  {{huov.gebr_naam}}  -->
     </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  props: ['taal_code'],
  data() {
    return {
      huov: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/huov/nwHuov.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "nwHuov"
          },
          nwHuov: {
            taal_code: this.taal_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.nwHuov;
            console.log('nwHuov', this.huov)
            /* window.open('https://www.villaforyou.nl/rdr/internal/bk/' + this.huov.gebr_encrid,'_blank'); */
            window.open(this.huov.url,'_blank');
            this.$router.push("/empty");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  
};

</script> 
